// FaviconUtil.js

export const changeFavicon = (newFaviconUrl) => {
  const favicon =
    document.querySelector("link[rel='shortcut icon']") ||
    document.createElement("link");
  favicon.type = "image/x-icon";
  favicon.rel = "icon";
  favicon.href = newFaviconUrl;

  document.head.appendChild(favicon);
};
